export enum UserType {
  User = 'user',
  Employee = 'employee',
  SuperUser = 'superUser'
}
